var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "ruleFormPackage",
          attrs: {
            model: _vm.ruleFormPackage,
            rules: _vm.rules,
            "label-position": "right",
          },
        },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { display: "flex" },
              attrs: { label: "Tên gói:", prop: "name" },
            },
            [
              _c("el-input", {
                staticClass: "no-border",
                attrs: {
                  placeholder: "Nhập tên gói...",
                  type: "text",
                  autocomplete: "off",
                },
                model: {
                  value: _vm.ruleFormPackage.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleFormPackage, "name", $$v)
                  },
                  expression: "ruleFormPackage.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { display: "flex" },
              attrs: { label: "Mô tả:", prop: "description" },
            },
            [
              _c("el-input", {
                staticClass: "no-border",
                attrs: {
                  placeholder: "Nhập mô tả cho gói...",
                  type: "text",
                  autocomplete: "off",
                },
                model: {
                  value: _vm.ruleFormPackage.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleFormPackage, "description", $$v)
                  },
                  expression: "ruleFormPackage.description",
                },
              }),
            ],
            1
          ),
          _c("el-form-item", [
            _c(
              "div",
              { staticStyle: { display: "flex", "justify-content": "end" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "success",
                      icon: "el-icon-circle-check",
                      loading: _vm.isLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.submitForm("ruleFormPackage")
                      },
                    },
                  },
                  [_vm._v("\n          Lưu\n        ")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger", icon: "el-icon-circle-close" },
                    on: { click: _vm.closeForm },
                  },
                  [_vm._v("\n          Đóng\n        ")]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }